namespace InvData.DayId {

    /**
     * Format date or dayId using our standard convention for date formatting.
     */
    export function format(dateOrDateIndex: Date | number): string {
        if (dateOrDateIndex === null || typeof dateOrDateIndex === "undefined") {
            return "";
        }

        return InvData.Util.DateIndexHelper.formatAsShortMonthDayYear(dateOrDateIndex);
    }

    export function toDate(dayId: number): Date {
        return InvData.Util.DateIndexHelper.getDateFromDateIndex(dayId);
    }

    export function today(): number {
        let todayId = forDate(new Date());
        return todayId;
    }

    export function yesterday(): number {
        let yesterdayId = forDate(new Date()) - 1;
        return yesterdayId;
    }

    export function forDateIndex(dateIndex: number, relativeTo: RelativeDate = RelativeDate.AsSpecified, offset: number = 0): number {
        let date = DayId.toDate(dateIndex);
        return DayId.forDate(date, relativeTo, offset);
    }

    export function toUtcTimestamp(timestamp: number){
        const date = new Date(timestamp);

        const utcTimestamp = Date.UTC(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            date.getHours(),
            date.getMinutes(),
            date.getSeconds(),
            date.getMilliseconds()
        );
        return utcTimestamp;
    }

    export function forDate(date: Date, relativeTo: RelativeDate = RelativeDate.AsSpecified, offset: number = 0): number {
        switch (relativeTo) {
            case RelativeDate.AsSpecified:
                {
                    if (offset != 0) {
                        throw "Offset must be zero for RelativeDate.AsSpecified.";
                    }

                    return InvData.Util.DateIndexHelper.getDateIndexFromDate(date);
                }

            case RelativeDate.MonthEnd:
                {
                    if (offset == 0)
                        return InvData.Util.DateIndexHelper.getDateIndexOfLastDayInMonth(date);
                    else if (offset > 0)
                        return DayId.forDateIndex(1 + InvData.Util.DateIndexHelper.getDateIndexOfLastDayInMonth(date), relativeTo, offset - 1);
                    else {
                        // offset < 0
                        return DayId.forDateIndex(InvData.Util.DateIndexHelper.getDateIndexOfLastDayInPreviousMonth(date), relativeTo, offset + 1);
                    }
                }

            case RelativeDate.PriorMonthEnd:
                {
                    if (offset == 0)
                        return InvData.Util.DateIndexHelper.getDateIndexOfLastDayInPreviousMonth(date);
                    else if (offset > 0)
                        return DayId.forDateIndex(1 + InvData.Util.DateIndexHelper.getDateIndexOfLastDayInMonth(date), relativeTo, offset - 1);
                    else {
                        // offset < 0
                        return DayId.forDateIndex(InvData.Util.DateIndexHelper.getDateIndexOfLastDayInPreviousMonth(date), relativeTo, offset + 1);
                    }
                }

            case RelativeDate.QuarterEnd:
                {
                    if (offset == 0)
                        return InvData.Util.DateIndexHelper.getDateIndexOfLastDayInQuarter(date);
                    else if (offset > 0)
                        return DayId.forDateIndex(1 + InvData.Util.DateIndexHelper.getDateIndexOfLastDayInQuarter(date), relativeTo, offset - 1);
                    else {
                        // offset < 0
                        return DayId.forDateIndex(InvData.Util.DateIndexHelper.getDateIndexOfLastDayInPreviousQuarter(date), relativeTo, offset + 1);
                    }
                }

            case RelativeDate.PriorQuarterEnd:
                {
                    if (offset == 0)
                        return InvData.Util.DateIndexHelper.getDateIndexOfLastDayInPreviousQuarter(date);
                    else if (offset > 0)
                        return DayId.forDateIndex(1 + InvData.Util.DateIndexHelper.getDateIndexOfLastDayInQuarter(date), relativeTo, offset - 1);
                    else {
                        // offset < 0
                        return DayId.forDateIndex(InvData.Util.DateIndexHelper.getDateIndexOfLastDayInPreviousQuarter(date), relativeTo, offset + 1);
                    }
                }

            case RelativeDate.YearEnd:
                {
                    if (offset == 0)
                        return InvData.Util.DateIndexHelper.getDateIndexOfLastDayInYear(date);
                    else if (offset > 0)
                        return DayId.forDateIndex(1 + InvData.Util.DateIndexHelper.getDateIndexOfLastDayInYear(date), relativeTo, offset - 1);
                    else {
                        // offset < 0
                        return DayId.forDateIndex(InvData.Util.DateIndexHelper.getDateIndexOfLastDayInPreviousYear(date), relativeTo, offset + 1);
                    }
                }

            case RelativeDate.PriorYearEnd:
                {
                    if (offset == 0)
                        return InvData.Util.DateIndexHelper.getDateIndexOfLastDayInPreviousYear(date);
                    else if (offset > 0)
                        return DayId.forDateIndex(1 + InvData.Util.DateIndexHelper.getDateIndexOfLastDayInYear(date), relativeTo, offset - 1);
                    else {
                        // offset < 0
                        return DayId.forDateIndex(InvData.Util.DateIndexHelper.getDateIndexOfLastDayInPreviousYear(date), relativeTo, offset + 1);
                    }
                }

            default:
                throw ("Unsupported RelativeDate: " + relativeTo);
        }
    }    
    
}

namespace InvData {

    export enum RelativeDate {
        AsSpecified,
        MonthEnd,
        PriorMonthEnd,
        QuarterEnd,
        PriorQuarterEnd,
        YearEnd,
        PriorYearEnd
    }

}

